export class InternalLinkUtils {
    public static resolveInternalLinksInHtml(
        html: string,
        maps: { pageHrefById: Map<string, string>; elementHrefBySlug: Map<string, string> }
    ) {
        if (!html) return "";
        const doc = new DOMParser().parseFromString(html, "text/html");
        const links = Array.from(doc.querySelectorAll<HTMLAnchorElement>("a"));

        for (const a of links) {
            // Clean inline styles pasted from editors
            a.removeAttribute("style");

            const pageId = a.getAttribute("data-internal-page-id") ?? a.dataset?.internalPageId ?? undefined;
            const elSlug = a.getAttribute("data-internal-element-slug") ?? a.dataset?.internalElementSlug ?? undefined;

            let href: string | undefined;
            if (pageId && maps.pageHrefById.has(pageId)) href = maps.pageHrefById.get(pageId)!;
            if (!href && elSlug && maps.elementHrefBySlug.has(elSlug)) href = maps.elementHrefBySlug.get(elSlug)!;

            if (href) {
                a.setAttribute("href", href);
                a.setAttribute("data-spa-link", "1"); // mark for delegated navigation
            } else if (pageId || elSlug) {
                // unwrap the <a> but keep its children/formatting
                InternalLinkUtils.unwrapAnchorPreserveChildren(a);
            }
        }

        return doc.body.innerHTML;
    }

    public static unwrapAnchorPreserveChildren(a: HTMLAnchorElement) {
        const parent = a.parentNode;
        if (!parent) return;
        while (a.firstChild) parent.insertBefore(a.firstChild, a);
        parent.removeChild(a);
    }
}
